import { isProdCn } from './envHelper';
import { t } from './helper/intl';

// import { ASSET_FROM_SYSTEM_TEMPLATE,ASSET_DIGTAL_HUMAN, } from "@/engine/LayerConstants"
interface IProps {
  [key: string | number]: number | string;
}

export const TIMEOUT = 300000;

// 画面比例
export const PICTURE_SCALE: IProps = {
  0: '9:16',
  1: '16:9',
};

export const PICTURE_SCALE_LIST = ['9:16', '16:9'];

export const WORK_MENU_TAB_COMMON_MAP: IProps = {
  9: '背景',
  2: '图片',
  5: '音频话术',
  8: '文本话术',
};

//资产类型对应片段类型 0-文本 1-音频
export const FRAGMENT_TYPE_MAP: Record<number, number> = {
  8: 0,
  5: 1,
};

export const LAYER_OPERATE_MENU: Record<number, string> = {
  1: '上移一层',
  2: '下移一层',
  3: '置顶',
  4: '置底',
};

// 背景素材分 我的、预设 两种类型
export const COMMON_BG_TYPE: Record<number, string> = {
  0: '我的',
  1: '预设',
};
export const COMMON_BG_TYPE_LIST = [0, 1];

export type EffectType = 'media.system' | 'media.user' | 'media.digital';

export const videoOpMinHeight = 334;
export const videoOpMinWidth = 220;

/******************************** 数字人相关种类********************************/
/**
 * 数字人相关素材的主种类：tcid
 */
export const TCID_FOR_DIGITAL = '40';

/**
 * 数字人主题模板主种类：tcid
 */
export const TCID_FOR_DIGITAL_THEME = '1';
/**
 * 单个数字人
 */
export const SUBTCID_FOR_DIGITAL = '5';
/**
 * 单个音色
 */
export const SUBTCID_FOR_TIMBRE = '6';

/**
 * 横竖兼容主题
 */

export const SUBTCID_FOR_NORMAL_THEME = '0';
/**
 * 竖屏主题模板
 */
// export const SUBTCID_FOR_VERTICAL_THEME = '4';
export const SUBTCID_FOR_VERTICAL_THEME = '121';

/**
 * 横屏主题模板
 */
// export const SUBTCID_FOR_HORIZONTAL_THEME = '3';
export const SUBTCID_FOR_HORIZONTAL_THEME = '120';

/**
 * background
 */
export const SUBTCID_FOR_BACKGROUND = '2';

/**
 * 视频
 */
export const SUBTCID_FOR_VIDEO = '1';

/**
 * 音乐
 */
export const SUBTCID_FOR_MUSIC = '0';

/************oss文件上传路径 dirSceneType **********/
/**
 * 用户头像
 */
export const OSS_TYPE_USER_AVATAR = 10;
/**
 * 用户资产
 */
export const OSS_TYPE_USER_ASSET = 20;
/**
 * 工程文件
 */
export const OSS_TYPE_USER_PROJECT = 30;

/**
 * 临时资产：
 */
export const OSS_TYPE_USER_TEMP = 50;

/**************视频导出参数start****************** */

export type EXPORT_RESOLUTION_TYPE = 360 | 480 | 720 | 1080;
/**
 * 分辨率默认值720
 */
export const EXPORT_RESOLUTION: EXPORT_RESOLUTION_TYPE = 720;

/**
 * 分辨率
 */
export const EXPORT_RESOLUTION_LIST = [360, 480, 720, 1080];

/**
 * 帧率列表
 */
export const EXPORT_FPS_LIST: Array<EXPORT_FPS_TYPE> = [60, 50, 30, 25];

/**
 * 帧率类型
 */
export type EXPORT_FPS_TYPE = 25 | 30 | 50 | 60;

// fps默认30
export const EXPORT_CURRENT_FPS: EXPORT_FPS_TYPE = 30;

/**
 * 导出质量 0推荐 1高质量 2快速导出
 */
export type EXPORT_QUALITY_TYPE = 0 | 1 | 2;

export const EXPORT_QUALITY: EXPORT_QUALITY_TYPE = 0;

/**************视频导出参数end****************** */

export type SaveStatus = 'unsave' | 'syncing' | 'synced' | 'err';
export const SAVE_STATUS_MAP: Record<SaveStatus, string> = {
  unsave: '未保存',
  syncing: '保存中',
  synced: '已保存',
  err: '保存失败',
};

// 新建工程是传参数
export const INIT_PROJECT_URL = 'INIT_PRJ';

/**
 * 默认的项目canvas大小，即rootcomp大小，设置为固定值，页面上缩放展示，解决页面展示模糊问题
 */
export let CANVAS_SIZE: Record<string, any> = {
  '9:16': {
    width: 720,
    height: 1280,
  },
  '3:4': {
    width: 600,
    height: 800,
  },
  '1:1': {
    width: 720,
    height: 720,
  },
  '16:9': {
    width: 1280,
    height: 720,
  },
  '4:3': {
    width: 800,
    height: 600,
  },
  '2:1': {
    width: 1200,
    height: 600,
  },
  '2:3': {
    width: 800,
    height: 1200,
  },
};

export const updateCommonCanvasSize = (ratio: string, w?: number, h?: number) => {
  // 存在，不需要更新
  if (CANVAS_SIZE[ratio]) return;
  let width = w,
    height = h;
  if (!w || !h) {
    [width, height] = ratio.split(':').map((i) => Number(i));
  }

  CANVAS_SIZE[ratio] = { width, height };
};

/**
 * 历史的草稿用的都是2:3的视频比例
 */
export const historyRatio = '2:3';

/**
 * 素材：数字人模块，请求服务端时传的model
 */
export const TEMPLATE_DIGITAL_MODEL = 'digitalHuman';

/**
 * 定制数字人列表type 1视频模板
 */
export const TEMPLATE_PERSONAL_TYPE_VIDEO = 1;

/**
 * 定制数字人列表type 2音频模板
 */
export const TEMPLATE_PERSONAL_TYPE_AUDIO = 2;

/**
 * 音色语言映射
 */
export const LANG_DIC: Record<string, string> = {
  zh: '中文',
  en: '英文',
};

/****************资产类型start**************** */
export type AssetTypeName =
  | 'FOLDER'
  | 'VIDEO'
  | 'PICTURE'
  | 'FONT'
  | 'AUDIO'
  | 'TIMBRE_AUDIO'
  | 'ZIP'
  | 'TEXT';
/**
 * 资产保存类型
 */
export const assetsType: Record<AssetTypeName, number> = {
  /**
   * 文件夹
   */
  FOLDER: 1,
  /**
   * 图片
   */
  PICTURE: 2,
  /**
   * 视频
   */
  VIDEO: 3,
  /**
   * 字体
   */
  FONT: 4,
  /**
   * 音频
   */
  AUDIO: 5,
  /**
   * 音色音频
   */
  TIMBRE_AUDIO: 6,
  /**
   * ZIP
   */
  ZIP: 7,
  /**
   * 文本
   */
  TEXT: 8,
};
/****************资产类型end**************** */

/****************Toast Msg********************/

export const ToastMsg = {
  // 暂未开放，敬请期待
  1: 'Not yet open, please wait',
  // 至少保留一个
  2: 'keep at least one',
  // 正在生成TTS，请生成完之后再导出
  3: 'Generating TTS. Please export after generating.',
  // 请先选择一个模板
  4: 'Please select a template first',
  //创建失败
  5: 'Failed to create project',
};

export const AGREEMENT_CONFIG = {
  oversea: {
    privicy: '/privacy',
    user: '/terms',
    member: '/member',
  },
};
/****************  qa和线上素材包区分  ********************/
const env = process.env.NEXT_PUBLIC_ENV;
export const GroupCodes = {
  Avatar:
    env === 'development' || env === 'qa' ? '202403221540061407' : '202404161358137038',
  Audio:
    env === 'development' || env === 'qa' ? '202311301057486843' : '202311301057486843',
  Template:
    env === 'development' || env === 'qa'
      ? '202403191424362110'
      : isProdCn
        ? '20240416140021919'
        : '202410301714279789',
  LipSyncAudioFY:
    env === 'development' || env === 'qa'
      ? '202402281612139132'
      : isProdCn
        ? '202408011637004037'
        : '202410301439229228',
  LipSyncAudio:
    env === 'development' || env === 'qa'
      ? '202402281612139132'
      : isProdCn
        ? '202402281612139132'
        : '202410301439229228',
  LipSyncAudioZh:
    env === 'development' || env === 'qa'
      ? '202407291529093136'
      : isProdCn
        ? '202407311016283768'
        : '202410301406067172',
  LipSyncAudioScriptZh:
    env === 'development' || env === 'qa' ? '202407291529093136' : '202311301057486843',
  LipSyncAudioEn:
    env === 'development' || env === 'qa'
      ? '202407291529318462'
      : isProdCn
        ? '202407311016473856'
        : '202410301406067171',
  LipSyncAudioOther:
    env === 'development' || env === 'qa'
      ? '202408121623471350'
      : isProdCn
        ? '202408121623471350'
        : '202410301450172424',
  // Avatar: '202404161358137038',
  // Audio: '202311301057486843',
  // Template: '20240416140021919',
  // LipSyncAudioFY: '202408011637004037',
  // LipSyncAudio: '202402281612139132',
  // LipSyncAudioZh: '202407311016283768',
  // LipSyncAudioEn: '202407311016473856',
};

type AudioGroupType = {
  [key: string]: {
    [key: string]: any;
  };
};
/**
 *  普通内置音色、唇音驱动音色线上、qa，国内海外区分
 */
export const AudioGroupCodes: AudioGroupType = {
  cn: {
    LipSyncAudio:
      env === 'development' || env === 'qa' ? '202402281612139132' : '202402281612139132',
    LipSyncAudioFY:
      env === 'development' || env === 'qa' ? '202402281612139132' : '202408011637004037',

    Audio:
      env === 'development' || env === 'qa' ? '202311301057486843' : '202311301057486843',
    // LipSyncAudio: '202402281612139132',
    // LipSyncAudioFY: '202408011637004037',

    // Audio: '202311301057486843',
  },
  oversea: {
    LipSyncAudio:
      env === 'development' || env === 'qa'
        ? '202402281612139132'
        : isProdCn
          ? '202408011637004037'
          : '202410301439229228',
    LipSyncAudioFY:
      env === 'development' || env === 'qa'
        ? '202402281612139132'
        : isProdCn
          ? '202408011637004037'
          : '202410301439229228',

    Audio:
      env === 'development' || env === 'qa' ? '202405231645322484' : '202402231008333105',
    // LipSyncAudio: '202402281612139132',
    // LipSyncAudioFY: '202408011637004037',

    // Audio: '202402231008333105',
  },
};

export type ModuleValueType = (typeof PACKAGE_MODULE)[keyof typeof PACKAGE_MODULE];
export type ModuleKeyType = keyof typeof PACKAGE_MODULE;

/**
 * 对应VCM素材包模块
 */
export const PACKAGE_MODULE = {
  /**
   * 数字人
   */
  Avatar: 'digitalHuman',
  /**
   * 脚本素材
   */
  Template: 'scriptTemplate',
  /**
   * 音色
   */
  Audio: 'timbre',
  /**
   * 唇音驱动 音色
   */
  LipSyncAudio: 'timbre',
  LipSyncAudioFY: 'timbre',
};
export const GroupCodesOfRegion = {};

export type ListTypeValueType = (typeof ServerListType)[keyof typeof ServerListType];
export type ListTypeKey = keyof typeof ServerListType;
/**
 * 服务端返回的任务、导出视频的类型，用来区分字幕、营销视频、唇音驱动等功能
 */
export const ServerListType = {
  /**
   * 视频制作
   */
  VIDEO_MAKE: 1,
  /**
   * 音频制作
   */
  AUDIO_MAKE: 2,
  /**
   * 视频训练
   */
  VIDEO_TRAIN: 3,
  /**
   * 音频训练
   */
  AUDIO_TRAIN: 4,
  /**
   * 视频导出
   */
  VIDEO_EXPORT: 5,
  /**
   * 视频翻译
   */
  VIDEO_TRANSLATE: 6,
  /**
   * 字幕擦除
   */
  CAPTION_CLEAROFF: 7,
  /**
   * 营销视频导出
   */
  VIDEO_SUBMIT_EXPORT: 8,
  /**
   * 快速分身训练
   */
  QUICK_CLONE_TRAIN: 9,
  /**
   * 快速分身导出
   */
  QUICK_CLONE_EXPORT: 10,
  /**
   * 数字人训练+音色克隆
   */
  NEW_CLONE: 11,
  /**
   * lip-sync
   */
  LIP_SYNC: 12,
  /**
   * 换脸
   */
  FACE_MERGE: 13,
  /**
   * 文本字幕翻译
   */
  BATCH_VIDEO_TRANS: 14,
  /**
   * 文本字幕翻译校准
   */
  BATCH_VIDEO_TRANS_RESUBMIT: 15,
  /**
   * 音频字幕翻译
   */
  BATCH_AUDIO_TRANS: 16,
  /**
   * 文本+音频字幕翻译
   */
  BATCH_VIDEO_AUDIO_TRANS: 17,
  /**
   * 音频字幕翻译校准
   */
  BATCH_AUDIO_TRANS_RESUBMIT: 18,
  /**
   * 文本+音频字幕翻译校准
   */
  BATCH_VIDEO_AUDIO_TRANS_RESUBMIT: 19,
  /**
   * 公共TOB图片数字人三维重建
   */
  COMMON_AVATAR_RECONSTRUCT: 101,
  /**
   * 公共TOB三维重建数字人驱动
   */
  COMMON_RECONSTRUCT_AVATAR_ANIMATION: 102,
  /*
   * 营销视频导出
   */
  Editor_Export_video: 30,
};

/**** 音色clone试听文案 *****/
export const CLONE_TEXT = [
  'Indulge in premium quality at unbeatable prices – shop now for limited-time deals!',
  'Upgrade your lifestyle with our cutting-edge technology, engineered for ultimate performance.',
  'Discover the secret to radiant skin: Our dermatologist-recommended skincare line is waiting for you.',
  'Create cherished memories: Thoughtful gifts, personalized keepsakes, and unique experiences for loved ones.',
  'Explore the world of sound: High-fidelity headphones, speakers, and audio systems for audiophiles and casual listeners alike.',
  'Transform your home into a haven of tranquility with our curated collection of elegant home decor.',
  'Say goodbye to clutter and hello to organization with our innovative storage solutions for every room.',
  'Find your perfect fit: Shop our extensive range of sizes and styles, designed to celebrate every body.',
  'Savor the aroma of freshly brewed perfection: Premium coffee beans, brewing accessories, and barista-grade equipment.',
  'Unwind in pure bliss: Luxurious bedding, plush towels, and spa-inspired bath essentials for ultimate relaxation.',
];
/**** 音色clone试听文案 END *****/

/************** 工程比例 end****************** */

// 3.0改版后的任务类型
export enum F_CLOUD_TASK_TYPE {
  /** f站视频生成 */
  F_VIDEO_GENERATE = 501,

  /** f站图片生成 */
  F_IMAGE_GENERATE = 502,

  /** f站音色克隆 */
  F_VOICE_CLONE = 503,

  /** f站文本转语音 */
  F_TEXT_TO_SPEECH = 504,

  /** f站换脸 */
  F_FACE_SWAP = 505,

  /** f站换头 */
  F_HEAD_SWAP = 506,

  /** f站图生数字人 */
  // F_IMAGE_CREATE_AVATAR = 507,

  /** f站【视频翻译】字幕翻译 */
  F_BATCH_SUBTITLE_TRANS = 508,

  /** f站【视频翻译】旁白翻译 */
  F_BATCH_AUDIO_TRANS = 509,

  /** f站【视频翻译】字幕翻译+旁白翻译 */
  F_BATCH_SUBTITLE_AUDIO_TRANS = 510,

  /** f站【多框视频翻译】字幕翻译 */
  F_MULTI_SUBTITLE_TRANS = 511,

  /** f站【多框视频翻译】字幕+旁白翻译 */
  F_MULTI_SUBTITLE_AUDIO_TRANS = 512,

  /** f站产品数字人 */
  F_PRODUCT_AVATAR = 513,

  /** f站数字人视频2.0 */
  F_AVATAR_VIDEO_2_0 = 514,

  // 图片翻译
  F_IMAGE_TRANSLATE = 515,

  // 图片高清
  F_IMAGE_ENHANCE = 516,

  // 智能擦除
  F_VIDEO_REMOVAL = 517,

  // 视频编辑
  F_VIDEO_EDIT = 518,

  // 爆款复刻（旧页 / 部分历史数据）
  F_VIRAL_REMAKE = 519,

  /** 爆款模板（模板表单提交产生的任务，与列表页「我的创作」查询一致） */
  F_VIRAL_TEMPLATE = 520,
}

export const enum ModelTypeEnum {
  T2V = 1,
  I2V = 2,
  T2I = 3,
  I2I = 4,
  VET = 6,
}

export const ModelTypeNameMap: Record<ModelTypeEnum, string> = {
  [ModelTypeEnum.T2V]: t('Agent-text2video'),
  [ModelTypeEnum.I2V]: t('6af3ef8d4c80899d639fffed70cca32e'),
  [ModelTypeEnum.T2I]: t('Agent-text2pic'),
  [ModelTypeEnum.I2I]: t('Agent-pic2pic'),
  [ModelTypeEnum.VET]: t('9613af8a82f375ffce54844fc0a470cc'),
};

// 功能名称枚举
/**
 * AI 功能枚举
 * 保持原始功能名称作为值，便于与后端 API 对接
 */
export enum AIFunction {
  Text2Video = 'text_2_video',
  Image2Video = 'image_2_video',
  Image2Image = 'image_2_image',
  Text2Image = 'text_2_image',
  VideoTranslate = 'video_translate',
  Avatar2 = 'avatar_2',
  ProductAvatar = 'product_avatar',
  FaceSwap = 'face_swap',
  HeadSwap = 'head_swap',
  VoiceClone = 'voice_clone',
  Text2Speech = 'text_2_speech',
  Removal = 'removal',
  ImageTranslate = 'image_translate',
  ImageEnhance = 'image_enhance',
  TopUpgrade = 'top_upgrade',
  VideoEdit = 'video_edit',
  ViralRemake = 'ad_clone',
  Library = 'library',
  Me = 'me',
  Other = 'other',
  Home = 'home',
  ViralTemplate = 'Template',
  AITools = 'ai_tools',
}

export const F_CLOUD_TASK_TYPE_TO_FUNCTION_NAME = {
  [F_CLOUD_TASK_TYPE.F_VIDEO_GENERATE]: AIFunction.Text2Video,
};

export const ROUTE_FROM = 'route_from';
export const FC_Feature = 'fc_feature';
